import { createContext, useContext } from 'react'

/**
 * Qual lista de interconsultas a tela mostra: `minhas` (só as do solicitante logado, onde ele
 * replica e registra desfecho) ou `equipe` (todas as da empresa, só para acompanhar — a linha não
 * diz quem é o solicitante, e réplica e desfecho são exclusivos dele).
 */
export type EscopoPareceres = 'minhas' | 'equipe'

const EscopoPareceresContext = createContext<EscopoPareceres>('minhas')

export const EscopoPareceresProvider = EscopoPareceresContext.Provider

export const useEscopoPareceres = () => useContext(EscopoPareceresContext)
